import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { bridalTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const BridalWearTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])
    const workingSinceOption = checkboxData.workSinceOption;
    const ServicedOfferedBridalOption = checkboxData.servicedOfferedBridal;
    const customizationbridalOption = checkboxData.customizationbridal;
    const storeTypebridalOption = checkboxData.storeTypebridal;

    const formik = useFormik({
        initialValues: {
            workingSince: merchant?.workingSince || [],
            serviceOffered: merchant?.serviceOffered || [],
            customization: merchant?.customization || [],
            storeType: merchant?.storeType || [],
        },
        enableReinitialize: true,
        validationSchema: bridalTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header bg-primary text-white'>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Services Offered</th>
                                                            <th style={{ width: '25%' }}>Customization</th>
                                                            <th style={{ width: '25%' }}>Store Type</th>

                                                        </tr>
                                                        <tr>

                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>

                                                            <td>{
                                                                merchant.serviceOffered
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.customization
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>


                                                            <td>{
                                                                merchant.storeType
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span >{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn btn-primary mb-2' onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>




                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Services Offered</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={ServicedOfferedBridalOption}
                                                            selected
                                                            value={formik.values.serviceOffered}
                                                            onChange={(serviceOffered) => formik.setFieldValue('serviceOffered', serviceOffered)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.serviceOffered && formik.errors.serviceOffered ? (
                                                            <div className="text-danger">{formik.errors.serviceOffered}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Customization</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={customizationbridalOption}
                                                            selected
                                                            value={formik.values.customization}
                                                            onChange={(customization) => formik.setFieldValue('customization', customization)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.customization && formik.errors.customization ? (
                                                            <div className="text-danger">{formik.errors.customization}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Store Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={storeTypebridalOption}
                                                            selected
                                                            value={formik.values.storeType}
                                                            onChange={(storeType) => formik.setFieldValue('storeType', storeType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.storeType && formik.errors.storeType ? (
                                                            <div className="text-danger">{formik.errors.storeType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn btn-primary' type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default BridalWearTTK